import React, { useEffect, useState } from "react";
import Button from "./Button";
import Heading from "./Heading";
import Section from "./Section";
import Tagline from "./Tagline";
import grid from "../Assets/grid.png";
import { Gradient } from "./Design/Roadmap";
import { client, urlFor } from "../../src/app/blogs/lib/sanity";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const TopBlogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    async function fetchBlogs() {
      const query = `
        *[_type == 'blog'] | order(_createdAt desc) [0...4] {
          title,
          smallDescription,
          "currentSlug": slug.current,
          titleImage,
          _createdAt
        }
      `;
      const data = await client.fetch(query);
      setBlogs(data);
    }

    fetchBlogs();
  }, []);

  const cardVariants = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", bounce: 0.3, duration: 0.7 },
    },
  };

  return (
    <Section className="via-n-9 to-n-8 py-16" id="topblogs">
      <div className="container max-w-6xl mx-auto px-4">
        <Heading
          tag="Your Knowledge Center"
          title="Crypto Learning Hub"
          className="text-center mb-12"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 relative z-10">
          {blogs.map((item) => {
            const date = new Date(item._createdAt).toLocaleDateString();

            return (
              <motion.div
                key={item.currentSlug}
                className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition duration-300 flex flex-col justify-between"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={cardVariants}
              >
                <div>
                  <div className="relative mb-5">
                    <img
                      src={urlFor(item.titleImage).width(600).height(350).url()}
                      alt={item.title}
                      className="rounded-xl w-full h-56 object-cover"
                    />
                    <img
                      src={grid}
                      alt="Grid"
                      className="absolute -top-5 -right-5 w-20 opacity-10 rotate-12"
                    />
                  </div>

                  <div className="flex flex-wrap items-center justify-between mb-4 text-sm text-gray-400">
                    <Tagline>{date}</Tagline>
                    <span className="bg-white text-black px-3 py-1 rounded-full text-xs font-medium">
                      Done
                    </span>
                  </div>

                  <h4 className="text-xl font-semibold text-white mb-3">
                    {item.title}
                  </h4>
                  <p className="text-gray-300 mb-6">{item.smallDescription}</p>
                </div>

                  <div className="flex justify-center mt-4">
                    <Link to={`/blogs/${item.currentSlug}`}>
                      <Button
                        text="Read More"
                        className="px-6 py-2 mx-auto block hover:bg-white hover:text-black transition-colors duration-300"
                      />
                    </Link>
                  </div>

              </motion.div>
            );
          })}
        </div>

        <Gradient />

        <div className="flex justify-center mt-14">
        <Link to="/blogs">
          <Button
            text="Read Blogs"
            className="px-6 py-3 mx-auto block hover:bg-white hover:text-black transition-colors duration-300"
          />
        </Link>
      </div>

      </div>
    </Section>
  );
};

export default TopBlogs;

